import {
    Datagrid,
    List,
    FunctionField,
    EditButton,
    ShowButton,
    TextInput,
} from "react-admin";
import React from "react";
import { FieldGuesser } from '@api-platform/admin';

const filters = [
    <TextInput label="Title" source="title" />,
    <TextInput label="Course ID" source="course" />,
];

export const TrackList = () => (
    <List actions={false} filters={filters}>
        <Datagrid>
            <FieldGuesser source="label" />
            <FieldGuesser source="startsAt" />
            <FieldGuesser source="endsAt" />
            <FieldGuesser source="createdAt" />
            <FieldGuesser source="updatedAt" />
            <FieldGuesser source="mediaUrl" />
            <>
                <ShowButton/>
                <EditButton/>
            </>
        </Datagrid>
    </List>
);
